<template>
  <v-app>
    <div class="page-container">
      <div class="navbar-container">
        <Navbar :title="$t('reservation_place')" :show-back-button="true" :show-refresh-button="true"
          @onRefresh="fethLayoutData(reserveDate?.date, false)" />
      </div>
      <v-container class="main-container reservation">
        <DatePicker :default-list-day="defaultListDay" :layout_id="floorSelected?.id" :default-day="defaultDay" :is-floor-change="isFloorChange"
          :onchange="selectDate" />

        <v-bottom-sheet v-if="floors.length > 1" v-model="sheetFloor" inset max-width="480px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" outlined elevation="0" class="lantai-picker"
              style="border: 1px solid #cecece;">
              <span class="text-caption">{{ floorSelected?.name }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24">
                <path d="M7,10L12,15L17,10H7Z" />
              </svg>
            </v-btn>
          </template>
          <v-sheet style="border-top-left-radius: 10px; border-top-right-radius: 10px">
            <div class="px-3 py-3">
              <div class="font-weight-bold">{{ $t('text_select_area') }}</div>

              <v-list>
                <v-list-item-group>
                  <v-list-item v-for="(option, index) in floors" :key="index" @click="floorChanged(option)"
                    class="item-payment px-1" style="border:none">
                    <v-row no-gutters class="d-flex align-center">
                      <v-col cols="8">
                        {{ option.name }}
                      </v-col>
                      <v-col cols="4" class="d-flex">
                        <v-spacer />
                        <v-list-item-action>
                          <div :class="`outer-circle ${isFloorSelected(option) ? 'selected-circle' : ''}`">
                            <div class="inner-circle"></div>
                          </div>
                        </v-list-item-action>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-sheet>
        </v-bottom-sheet>

        <div class="d-flex align-center justify-space-between">
          <CheckboxPlace is-active color="success" :label="$t('text_selected')" />
          <CheckboxPlace :label="$t('text_available')" color="#fafafa" />
          <CheckboxPlace is-filed :label="$t('text_not_available')" disabled />
        </div>
      </v-container>

      <div class="table-layout"
        v-if="isDevMode || (!reserveDate?.is_closing_dates && !reserveDate?.can_not_be_used && !isAllTablesBooked)">
        <LayoutReservation
          :layoutImage="layoutSetting.layoutImage"
          :meja="floorSelected?.items || []"
          :reserve-date="reserveDate"
          :zoom-scale="layoutSetting.zoomScale"
          :x="layoutSetting.x"
          :y="layoutSetting.y"
          :button-width="layoutSetting.buttonWidth"
          :button-height="layoutSetting.buttonHeight"
          :rect-button-width="layoutSetting.rectButtonWidth"
          :rect-button-height="layoutSetting.rectButtonHeight"
          :circle-button-width="layoutSetting.circleButtonWidth"
          :circle-button-height="layoutSetting.circleButtonHeight"
          :font-size="layoutSetting.fontSize"
          :circle-font-size="layoutSetting.circleFontSize"
          :custom-content="layoutSetting.customContent"
          @click="openBottomSheet"
        />
      </div>

      <template v-else-if="reserveDate?.can_not_be_used && reserveDate?.availibility_details?.store_closed?.is_">
        <ClosedStore @click="goToAlreadyBooked" />
      </template>
      <template
        v-else-if="reserveDate?.can_not_be_used && reserveDate?.availibility_details?.store_temporarily_closed?.is_">
        <TemporalyClosed :title="reserveDate?.availibility_details?.store_temporarily_closed?.description"
          @click="goToAlreadyBooked" />
      </template>
      <template
        v-else-if="reserveDate?.can_not_be_used && reserveDate?.availibility_details?.reservations_not_available?.is_">
        <NotAvailabelLayout @click="goToAlreadyBooked" />
      </template>
      <template
        v-else-if="(reserveDate?.can_not_be_used && reserveDate?.availibility_details?.full_reservation_schedule?.is_ || isAllTablesBooked)">
        <IsFullLayout @click="goToAlreadyBooked" />
      </template>
      <template v-else>
        <ClosedStore @click="goToAlreadyBooked" />
      </template>

      <div class="mt-4 card-scroll-horizontal">
        <v-card v-for="(item, index) in cartReservations" :key="index" class="rounded-lg item-reservation" :style="findInvalidOrder(item) ? 'border: 2px solid red' : ''">
          <div class="d-flex justify-start" style="position: relative">
            <v-avatar class="ma-3 rounded-lg" size="90" tile>
              <v-img style="border-radius: 10px;" :style="findInvalidOrder(item) ? 'filter: grayscale(1)' : ''" :src="item.item_place_reservation?.photo_md"></v-img>
            </v-avatar>
            <v-card-text class="d-flex flex-column pl-0" style="width: max-content">
              <span class="d-flex align-center text-caption" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : ''">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 11" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.9981 0.166687C1.34647 0.166687 0.790305 0.637677 0.682974 1.2804L0.348987 3.2804C0.213248 4.09324 0.840021 4.83335 1.66411 4.83335H2.71382V10.3426C2.71382 10.6137 2.93352 10.8334 3.20453 10.8334C3.44967 10.8334 3.6572 10.6525 3.69066 10.4096L4.09151 7.50002H9.90845L10.3093 10.4096C10.3428 10.6525 10.5503 10.8334 10.7954 10.8334C11.0664 10.8334 11.2861 10.6137 11.2861 10.3426V4.83335H12.3358C13.1599 4.83335 13.7867 4.09324 13.651 3.2804L13.317 1.2804C13.2097 0.637678 12.6535 0.166687 12.0019 0.166687H1.9981ZM9.72476 6.16669L9.5536 4.92434C9.54938 4.89371 9.54731 4.86334 9.54725 4.83335H4.45272C4.45266 4.86333 4.45058 4.89371 4.44636 4.92434L4.27521 6.16669H9.72476ZM1.9981 1.50002L12.0019 1.50002L12.3358 3.50002L1.66411 3.50002L1.9981 1.50002Z"
                    fill="currentColor" />
                </svg>
                {{ item.name }}
              </span>
              <span v-if="item.item_place_reservation" class="d-flex align-center text-caption" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : ''">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 17 17" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                    fill="currentColor" />
                </svg>
                {{ item.item_place_reservation?.capacity ?? "-" }} {{ $t('text_persons') }}
              </span>
              <span class="d-flex align-center text-caption" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : ''">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14" class="mr-2"
                  viewBox="0 0 24 24">
                  <path
                    d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                </svg>
                {{ item.reservation_date?.date_day }}
                {{ item.reservation_date?.date_month }}, {{ item.reserve_time }}
              </span>
              <div class="price blue--text font-weight-bold mt-1" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : item?.special_price?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                {{ item?.item_place_reservation?.fprice ?? "-" }}
              </div>
              <div v-if="item?.special_price?.with_special_price === 1" class="price blue--text font-weight-bold" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : ''">
                {{ item?.special_price?.fspecial_price ?? "-" }}
              </div>
            </v-card-text>
          </div>
          <!-- action delete item absolute top right -->
          <v-btn color="error" class="delete-item-action" style="cursor: pointer" icon @click="removeItem(item)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18" viewBox="0 0 24 24">
              <path
                d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
            </svg>
          </v-btn>
        </v-card>
      </div>

      <v-bottom-sheet v-model="sheetForSeat" inset max-width="480px">
        <v-sheet class="px-3 py-2 sheet" :style="windowHeight < 573 ? 'height: 80vh; overflow-y: scroll' : ''" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <div class="sheet-content">
            <div class="time-layout-duration" style="display: block;">
              <img :src="selectedReservation?.item_place_reservation?.photo_md" alt=""
                style="width: 100%;height: 200px;object-fit: cover;margin: 0 auto;border-radius: 15px;" />
            </div>
            <div class="d-flex align-center justify-space-between">
              <span class="d-flex align-center" style="font-weight: 700;">
                <svg class="mr-1" width="14" height="11" viewBox="0 0 14 11" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.9981 0.166687C1.34647 0.166687 0.790305 0.637677 0.682974 1.2804L0.348987 3.2804C0.213248 4.09324 0.840021 4.83335 1.66411 4.83335H2.71382V10.3426C2.71382 10.6137 2.93352 10.8334 3.20453 10.8334C3.44967 10.8334 3.6572 10.6525 3.69066 10.4096L4.09151 7.50002H9.90845L10.3093 10.4096C10.3428 10.6525 10.5503 10.8334 10.7954 10.8334C11.0664 10.8334 11.2861 10.6137 11.2861 10.3426V4.83335H12.3358C13.1599 4.83335 13.7867 4.09324 13.651 3.2804L13.317 1.2804C13.2097 0.637678 12.6535 0.166687 12.0019 0.166687H1.9981ZM9.72476 6.16669L9.5536 4.92434C9.54938 4.89371 9.54731 4.86334 9.54725 4.83335H4.45272C4.45266 4.86333 4.45058 4.89371 4.44636 4.92434L4.27521 6.16669H9.72476ZM1.9981 1.50002L12.0019 1.50002L12.3358 3.50002L1.66411 3.50002L1.9981 1.50002Z"
                    fill="#767676" />
                </svg>
                {{ selectedReservation?.name }}
              </span>
              <span v-if="selectedReservation?.item_place_reservation" class="d-flex align-center"
                style="font-weight: 700;">
                <svg class="mr-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                    fill="#767676" />
                </svg>
                {{
                  selectedReservation?.item_place_reservation?.capacity ?? "-"
                }}
                {{ $t('text_persons') }}
              </span>
            </div>

            <template v-if="isBidTable(selectedReservation)">
              <div v-if="[`R41`, `R42`, `R43`, `R44`, `R45`, `R46`, `R47`, `R48`, `R49`, `R50`].includes(selectedReservation?.name)" class="description d-flex flex-column mt-2">
                <ol>
                  <li>{{ $t('custom_desc.li1') }}</li>
                  <li>{{ $t('custom_desc.li2') }}</li>
                  <li>{{ $t('custom_desc.li3') }}</li>
                </ol>
              </div>
              <div v-else class="description d-flex flex-column mt-2">
                <ol>
                  <li>{{ $t('custom_desc.li4') }}</li>
                  <li>{{ $t('custom_desc.li5') }}</li>
                </ol>
              </div>
            </template>

            <template v-else>
              <div class="price blue--text font-weight-large mt-1" style="font-weight: 700;" :style="selectedReservation?.special_price?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                {{ selectedReservation?.item_place_reservation?.fprice ?? "-" }}
              </div>
              <div v-if="selectedReservation?.special_price?.with_special_price === 1" class="price blue--text font-weight-large" style="font-weight: 700;">
                {{ selectedReservation?.special_price?.fspecial_price ?? "-" }}
              </div>
              <div class="description d-flex flex-column mt-2">
                <span class="text-bold" style="font-weight: 700;">{{ $t('text_description') }}</span>
                <!-- <span class="deskripsi text-caption">{{
                  selectedReservation?.item_place_reservation?.notes ?? "-"
                }}</span> -->
                <template>
                  <div class="deskripsi" style="max-height: 75px;overflow-y: scroll;">
                    <span
                    v-if="selectedReservation?.item_place_reservation?.notes?.length > 110 && !readMoreActivated"
                    v-html="`${selectedReservation?.item_place_reservation?.notes?.slice(0, 110)}...` ?? '-'"
                    class="text-captio"
                    >
                  </span>
                  <!-- {{ selectedReservation?.item_place_reservation?.notes?.slice(0, 110) }}...  -->
                    <a class="text-captio" style="text-decoration: none;" v-if="selectedReservation?.item_place_reservation?.notes?.length > 110 && !readMoreActivated" @click="activateReadMore" href="#">
                      Read more
                    </a>
                    <span v-else class="text-captio" v-html="selectedReservation?.item_place_reservation?.notes?.replace(/\n/g, '<br />') ?? '-'"></span>
                    <a class="text-captio" style="text-decoration: none;" v-if="readMoreActivated" @click="activateReadMore" href="#">
                      Read less...
                    </a>
                  </div>
                </template>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="time-option">
                <div class="text-bold" style="font-weight: 700;">
                  <v-icon class="mr-1" size="30">mdi-calendar-month</v-icon>{{ reserveDate?.fdate }}
                </div>
                <span class="text-bold" style="font-weight: 700;">{{ $t('text_select_visit_time') }}</span>
                <div class="time-picker mt-2">
                  <div class="d-flex justify-space-between reservasi_picker align-center" style="gap: 10px;">
                    <div class="d-flex flex-column w-100" style="width: 100%;">
                      <span style="font-size: small;">{{ $t('text_hours') }}</span>
                      <vue-timepicker v-model="hour_selected" close-on-complete :hour-range="range_hour"
                        @change="hourChange" format="HH" :hour-label="$t('text_hours')" :placeholder="$t('text_hours')" input-class="time_picke"
                        input-width="100%" drop-direction="auto" auto-scroll></vue-timepicker>
                    </div>
                    <span>:</span>
                    <div class="d-flex flex-column w-100" style="width: 100%;">
                      <span style="font-size: small;">{{ $t('text_minutes') }}</span>
                      <vue-timepicker v-model="minute_selected" :minute-interval="1" close-on-complete
                        :minute-range="range_minute" format="mm" :minute-label="$t('text_minutes')" :placeholder="$t('text_minutes')"
                        @change="minuteChange" input-class="time_picke" input-width="100%" drop-direction="auto"
                        auto-scroll></vue-timepicker>
                    </div>
                  </div>
                  <div class="btn-booking mt-4">
                    <v-btn color="success" style="width: 100%" :elevation="0" @click="toggleSeatSelection"
                      :disabled="loading_booking || !hour_selected.HH || !minute_selected.mm">{{ $t('text_booking') }}</v-btn>
                  </div>
                </div>
              </div>
            </template>

          </div>
        </v-sheet>
      </v-bottom-sheet>

      <v-container>
        <div class="btn-nav-footer" style="border: none;">
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="font-weight-large" style="font-weight: 700;">
              Total ({{ isCartLength }} {{ $t('text_meja') }})
            </span>
            <span class="font-weight-large" style="font-weight: 700;">
              {{ formatCurrency(subTotalReservationPrice, true) }}
            </span>
          </div>
          <v-btn color="success" style="width: 100%" :disabled="getLoadingAxiosState || loading_booking || !isCartLength" :elevation="0" class="btn-submit"
            @click="handleCheckout">
            {{ $t('text_booking') }}
          </v-btn>
        </div>
      </v-container>

      <v-dialog v-model="dialog" width="360" persistent>
        <v-card class="d-flex flex-column align-center justify-center rounded-xl pa-2">
          <v-card-title> {{ $t('text_want_to_book_table') }} </v-card-title>

          <v-card-text class="text-center">
            {{ $t('text_delete_same_table_booking') }}
          </v-card-text>

          <v-card-actions>
            <div class="d-flex align-center" style="gap: 14px">
              <v-btn color="white" small @click="dialog = false"> {{ $t('text_cancel') }} </v-btn>
              <v-btn color="primary" small @click="checkAvailabilityBooking" :disabled="loading_booking">
                {{ $t('text_yes_next') }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
// import axios from "axios";
import Navbar from "@/components/Layouts/Navbar.vue";
import DatePicker from "@/components/DatePicker.vue";
import CheckboxPlace from "@/components/CheckboxPlace.vue";
import isObjectEmpty from "@/utils/isObjectEmpty";
import LayoutReservation from "@/components/LayoutReservation.vue";
import NotAvailabelLayout from "@/components/not-availabel/NotAvailabelLayout.vue";
import IsFullLayout from "@/components/not-availabel/IsFullLayout.vue";
import ClosedStore from "@/components/not-availabel/ClosedStore.vue";
import TemporalyClosed from "@/components/not-availabel/TemporalyClosed.vue";
import { mapGetters } from "vuex";
import { formatCurrency } from "@/utils/currencyUtils";
import { getLayout } from "@/api/layout";
import { getReserVationTime, checkSpecialPrice, checkreservationAvailability } from '@/api/reservation-time';
// import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { setQueryParam } from '@/utils/customQuery'
export default {
  name: "PlaceReservation",
  components: {
    Navbar,
    DatePicker,
    CheckboxPlace,
    LayoutReservation,
    NotAvailabelLayout,
    IsFullLayout,
    ClosedStore,
    TemporalyClosed,
    // VueTimepicker
  },

  data() {
    const startDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 5);

    return {
      serveStatus: process.env.VUE_APP_SERVE,
      isDevMode: process.env.VUE_APP_RESERVATION === 'development',
      startDate: startDate.toISOString().substr(0, 10),
      logoUrl: this.$store.state?.store_data?.logo, //"/images/avatar.png",
      sheetFloor: false,
      sheetForSeat: false,
      // tableLayoutImg: "@/assets/images/layout-withprice.jpeg",
      tableLayoutImg: "@/assets/images/original-layout.jpg",
      floors: [],
      floorSelected: null,
      isFloorChange: false,
      selectedReservation: null,
      seatItemSelected: [],
      reserveDate: null,
      isMounted: false,
      timeSelected: null,
      defaultListDay: [],
      defaultDay: null,
      resetSelectTime: false,
      dialog: false,
      range_hour: [],
      range_minute: null,
      hour_selected: {
        HH: null
      },
      minute_selected: {
        mm: null
      },
      readMoreActivated: false,
      loading_booking: false,
      invalid_order: [],
      special_price: null,
      layoutSetting: {
        layoutImage: "",
        zoomScale: 1,
        x: 0,
        y: 0,
        buttonWidth: 18,
        buttonHeight: 18,
        rectButtonWidth: 30,
        rectButtonHeight: 14,
        circleButtonWidth: 18,
        circleButtonHeight: 18,
        fontSize: 5,
        circleFontSize: 4,
        customContent: [],
      },
      windowHeight: window.innerHeight,
    };
  },

  watch: {
    sheetForSeat(newVal) {
      if (!newVal) {
        this.timeSelected = null
        this.hour_selected.HH = null
        this.minute_selected.mm = null
      }
    },
    timeSelected(newTime) {
      if (!`${newTime}`.includes('null')) {
        setTimeout(() => {
          this.getSpecialPrice(newTime)
        }, 500);
      }
    },
    getUrlDomain(payload) {
        if (payload) {
            this.setImageLayout(payload)
        }
    },
  },

  mounted() {
    if (this.getUrlDomain) {
        this.setImageLayout(this.getUrlDomain);
    }
    setTimeout(() => {
      this.fethLayoutData(this.startDate);
      const listCart = this.$store.getters.dataCartReservation ?? []
      if (listCart.length > 0) {
        this.checkAvailability({
          callback: (data) => {}
        })
      }
      this.isMounted = true;
    }, 1000);

    this.$nextTick(() => {
      window?.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() { 
    window?.removeEventListener('resize', this.onResize); 
  },

  computed: {
    cartReservations() {
      return this.$store.getters.dataCartReservation;
    },
    isCartLength() {
      return this.cartReservations.length;
    },
    itemInCart() {
      return this.cartReservations.find(
        (cart) => cart.name === this.selectedReservation.name
      );
    },
    isAllTablesBooked() {
      return this.floorSelected?.items.every((item) => item.is_table_booked === 1);
    },
    ...mapGetters(["subTotalReservationPrice", "getLoadingAxiosState", "getUrlDomain"]),
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    },
    setImageLayout(url_id) {
      const now = new Date();
      const today = now.toISOString().split('T')[0];
      // const daySelected = this.reserveDate?.date;
      // console.log('daySelected', daySelected)
      // console.log('daySelected l', daySelected === '2025-12-31')
      
        const defaultImage = require("@/assets/images/original-layout2.jpg");
        const defaultSetting = {
              layoutImage: defaultImage,
              zoomScale: 1,
              x: 0,
              y: 0,
              buttonWidth: 18,
              buttonHeight: 18,
              rectButtonWidth: 30,
              rectButtonHeight: 14,
              circleButtonWidth: 18,
              circleButtonHeight: 18,
              fontSize: 5,
              circleFontSize: 4,
              cssLoader: null
        };
        const customContent = [
                // { type: 'text', content: '17 agustus special event, minimum spending 1.000.000 for all table' },
                // { type: 'text', content: 'For information on the availability table, please contact the hotline number +62 811-3911-168' },
              ]
        switch (url_id) {
            case 'allinolsera2':
            case 'jakartatest':
                this.layoutSetting = {
                  ...defaultSetting,
                  customContent: today >= '2024-08-20' ? customContent : []
                };
                break;
            case 'infinitybeachclub':
                this.layoutSetting = {
                  ...defaultSetting,
                  // ...(daySelected === '2025-12-31' ? { 
                  //   cssLoader: () => import('@/assets/css/infinitybeachclub_31_des_25.css') 
                  // } : {
                  //   cssLoader: () => import('@/assets/css/infinitybeachclub.css')
                  // }),
                  customContent: today === '2025-12-31' ? customContent : []
                };
                break;
            case 'infinitybeachtest':
                this.layoutSetting = {
                  ...defaultSetting,
                  // ...(daySelected === '2025-12-31' ? { 
                  //   cssLoader: () => import('@/assets/css/infinitybeachclub_31_des_25.css') 
                  // } : {
                  //   cssLoader: () => import('@/assets/css/infinitybeachclub.css')
                  // }),
                  customContent: today === '2025-12-31' ? customContent : []
                };
                break;
            case 'deepseabeachclub':
                this.layoutSetting = {
                    ...defaultSetting,
                    layoutImage: require("@/assets/images/deepseabeachclub/deepsea3.jpg"),
                    x: -144,
                    y: -169,
                    zoomScale: 1.44,
                    buttonWidth: 12,
                    buttonHeight: 12,
                    fontSize: 4,
                    customContent: [],
                    // cssLoader: () => import('@/assets/css/deepseabeachclub.css')
                }
                break;
            case 'atlantisbeachclub':
                this.layoutSetting = {
                    ...defaultSetting,
                    layoutImage: require("@/assets/images/atlantisbeachclub/atlantis3.jpg"),
                    zoomScale: 1.2,
                    x: -88,
                    y: -25,
                    buttonWidth: 12,
                    buttonHeight: 12,
                    circleButtonWidth: 20,
                    circleButtonHeight: 20,
                    rectButtonWidth: 20,
                    rectButtonHeight: 12,
                    circleFontSize: 6,
                    fontSize: 4,
                    customContent: [],
                    // cssLoader: () => import('@/assets/css/atlantisbeachclub.css')
                };
                break;
            default:
                break;
        }

        // if (this.layoutSetting.cssLoader) {
        //     this.layoutSetting.cssLoader();
        // }
    },
    isBidTable(item) {
      if (this.getUrlDomain === "atlantisbeachclub" && ["SF1", "SF2", "SF3", "SF4", "BID", "R41", "R42", "R43", "R44", "R45", "R46", "R47", "R48", "R49", "R50"].includes(item?.name)) {
        return true
      } else if (this.getUrlDomain === "deepseabeachclub" && ["SF1", "SF2", "SF3", "SF4", "R41", "R42", "R43", "R44", "R45", "R46", "R47", "R48", "R49", "R50"].includes(item?.name)) {
        return true
      } else {
        return false
      }
    },
    formatCurrency,
    findInvalidOrder(item) {
      return this.invalid_order.find(
        (invalid) => parseInt(invalid.layout_item_id) === item.id
      )
    },
    activateReadMore(){
        this.readMoreActivated = !this.readMoreActivated
    },
    cariMenitBerdasarkanJam(data, jamYangDicari) {
      function getMinutesFromTime(time) {
        const parts = time.split(":");
        if (parts.length === 2) {
          return parseInt(parts[1], 10);
        }
        return null;
      }

      const menitYangDicari = data.map(item => {
        if (item.fstart_time.startsWith(jamYangDicari)) {
          return getMinutesFromTime(item.fstart_time);
        }
        if (item.fend_time.startsWith(jamYangDicari)) {
          return getMinutesFromTime(item.fend_time);
        }
        return null;
      });

      return menitYangDicari.filter(menit => menit !== null);
    },
    selectDate(day) {
      this.reserveDate = day;
      this.fethLayoutData(day?.date, true);

      const allTime = day?.times;
      const mapTime = allTime
        // .filter((item) => item.can_not_be_used !== 1)
        .map(item => {
          const startTimeParts = item.fstart_time.split(':');
          const endTimeParts = item.fend_time.split(':');
          const startHour = parseInt(startTimeParts[0]);
          const endHour = parseInt(endTimeParts[0]);
          return [startHour, endHour];
        });

      this.range_hour = mapTime;
      this.isMounted = false;
    },
    hourChange(newHour) {
      const { HH } = newHour.data;
      if (HH && HH !== "") {
        const hour = String(HH).padStart(2, '0')
        const minutes = this.cariMenitBerdasarkanJam(this.reserveDate?.times, hour)
        if (minutes.length) {
          // this.range_minute = [[...minutes, 59]]
          this.minute_selected.mm = `${String(minutes[0]).padStart(2, '0')}`
        } else {
          this.minute_selected.mm = null
          this.range_minute = null
        }
        this.timeSelected = `${HH}:${this.minute_selected.mm}`
      } else {
        this.timeSelected = null
        this.minute_selected.mm = null
      }
    },
    minuteChange(newMinute) {
      const { mm } = newMinute.data;
      if (mm && mm !== "" && this.hour_selected.HH !== "") {
        const time = `${this.hour_selected.HH}:${mm}`
        this.timeSelected = time;
      } else {
        this.timeSelected = null
      }
    },
    async getSpecialPrice(time) {
      // if (["allinolsera2", "infinitybeachclub", "jakartatest"].includes(this.getUrlDomain) && this.serveStatus === "staging") {
      if (["infinitybeachtest", 'infinitybeachclub'].includes(this.getUrlDomain)) {
        try {
            const { data } = await checkSpecialPrice({
              reserve_date: this.reserveDate.date,
              reserve_time: time,
              item_place_reservation_id: this.selectedReservation.item_place_reservation.id
            }).then(res => res.data);
            this.selectedReservation = { ...this.selectedReservation, special_price: data }
        } catch (e) {
          console.log('getSpecialPrice', e);
          this.$store.state.show_error = true
          this.$store.state.error_message = e.data.message
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    floorChanged(option) {
      this.floorSelected = option;
      this.isFloorChange = true;
      this.defaultDay = this.reserveDate;
      // this.fethLayoutData(this.reserveDate?.date, true);
      this.sheetFloor = false;
      // console.log("option", option);
    },
    isFloorSelected(item) {
      return item.id === this.floorSelected?.id;
    },
    openBottomSheet(item) {
      this.selectedReservation = item;
      this.sheetForSeat = true;
      const itemCart = this.cartReservations.find(
        (cart) => cart.id === item.id && cart.reservation_date.date === this.reserveDate.date
      );
      // console.log("item", this.selectedReservation);
      if (!isObjectEmpty(itemCart)) {
        // this.timeSelected = itemCart.reserve_time;
        this.hour_selected.HH = itemCart.hour;
        setTimeout(() => {
          this.minute_selected.mm = itemCart.minute;
        }, 200);
      }
    },
    toggleSeatSelection() {
      if (
        !isObjectEmpty(this.itemInCart) &&
        this.itemInCart.reservation_date.date !== this.reserveDate.date
      ) {
        this.dialog = true;
        return;
      } else {
        this.checkAvailabilityBooking()
      }
    },
    async checkAvailabilityBooking() {
      this.loading_booking = true
      try {
        const { data } = await checkreservationAvailability({
          reserve_date: this.reserveDate.date,
          reserve_time: this.timeSelected,
          layout_item_id: this.selectedReservation.id
        }).then(res => res.data);
        this.toggleAddToCart(data?.special_price);
      } catch (e) {
        console.log('error', e);
        this.$store.state.show_error = true
        this.$store.state.error_message = e.res?.data?.message ?? e.res?.error?.message
        this.$store.state.error_type = e.res?.status
      } finally {
        this.loading_booking = false
        this.reserveDate = this.reserveDate
        this.floorSelected = this.floorSelected
      }
      // this.toggleAddToCart();
    },
    toggleAddToCart(special_price) {
      const reservationData = [
        {
          floor: this.floorSelected,
          reservation_date: this.reserveDate,
          reserve_time: this.timeSelected,
          hour: this.hour_selected.HH,
          minute: this.minute_selected.mm,
          special_price: special_price,
          ...this.selectedReservation,
        },
      ];
      this.$store.dispatch("addItemReservation", reservationData);
      this.sheetForSeat = false;
      this.dialog = false;
      this.hour_selected.HH = null;
      this.minute_selected.mm = null;
    },
    removeItem(item) {
      this.$store.dispatch("removeItemReservation", item);
    },
    async fethLayoutData(date, select_date = false) {
      this.loading_booking = true
      // console.log("starDate", { reserv_date: date });
      const listCart = this.$store.getters.dataCartReservation ?? [];
      try {
        const { data } = await getLayout({
          reserv_date: date,
        }).then((res) => res.data);
        let firstData = data[0];

        if (this.getUrlDomain) {
            this.setImageLayout(this.getUrlDomain);
        }

        // filter floor selected from cart
        if (["deepseabeachclub", "atlantisbeachclub"].includes(this.getUrlDomain)) {
          const filter = data.filter((item) => item.name.toLowerCase() === "event")
          if (filter.length > 0) {
            this.floors = filter;
            firstData = filter[0];
          } else {
            this.floors = data;
            firstData = data[0];
          }
        } else {
          this.floors = data;
          firstData = data[0];
        }

        // check if some item in cart and set floor selected from cart resto_layout_id
        if (listCart.length > 0 && this.isMounted) {
          const itemCart = listCart[0];
          const floorCart = data.find((item) => item.id === itemCart.resto_layout_id);
          this.floorSelected = floorCart;
        } else {
          this.floorSelected = select_date ? data?.find((item) => item.id === this.floorSelected?.id) : firstData;
        }
        // console.log("floor selected", this.floorSelected);
      } catch (e) {
        this.$store.state.show_error = true;
        this.$store.state.error_message = e.data.message
        this.$store.state.error_type = e.statusCode;
      } finally {
        this.loading_booking = false
      }
    },
    async checkAvailability ({ callback = () => {} }) {
      this.loading_booking = true
      const dataCart = this.cartReservations.map((item) => ({
        reserve_date: item.reservation_date.date,
        reserve_time: item.reserve_time,
        layout_item_id: item.id
      }))
      try {
        const { data } = await checkreservationAvailability(dataCart).then(res => res.data);
        // update data cart
        data.forEach(item => {
          const findInCart = this.cartReservations.find((cart) => cart?.item_place_reservation?.id === item.details?.id)
          const newCart = [{
            ...findInCart,
            item_place_reservation: item.details,
            special_price: item.special_price
          }]
          this.$store.dispatch("addItemReservation", newCart);
        })

        const invalidData = data.filter(item => item.status !== 200)
        this.invalid_order = invalidData
        if (invalidData.length > 0) {
          this.$store.state.show_error = true
          this.$store.state.error_message = invalidData[0].message
        } else {
          callback(data)
        }
      } catch (e) {
        console.log('error', e);
        this.$store.state.show_error = true
        this.$store.state.error_message = e.res?.data?.message ?? e.res?.error?.message
        this.$store.state.error_type = e.res?.status
      } finally {
        this.loading_booking = false
      }
    },
    async handleCheckout() {
      this.checkAvailability({
        callback: (data) => {
          this.$store.dispatch("set_router_data", { name: 'checkout' });
          setQueryParam('page', 'checkout')
          this.$store.dispatch("remove_order");
          const authData = localStorage.getItem('olselforder_auth_data')
          if (authData) {
            const auth_data = JSON.parse(authData)
            this.$store.dispatch("setTokenAnatarinmakan", auth_data);
          } else {
            window.location.reload();
          }
        }
      })
    },
    async goToAlreadyBooked() {
      const startDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);


      const lastDate = new Date(this.reserveDate?.date)
      lastDate.setDate(lastDate.getDate() + 1);
      const nextDay = lastDate.toISOString().substr(0, 10);
      try {
        const { data } = await getReserVationTime({
          start_date: this.isAllTablesBooked ? nextDay : startDate,
          end_date: endDate,
          show_times: 1,
          available: 1,
          resto_layout_id: this.floorSelected?.id,
        }).then((res) => res.data);

        this.defaultListDay = data;
        if (data.length > 0) {
          const day = data[0];
          this.reserveDate = data[0];
          this.defaultDay = data[0];
          this.selectDate(day);
        }
      } catch (e) {
        this.$store.state.show_error = true;
        this.$store.state.error_message = e.message;
        this.$store.state.error_type = e.statusCode;
      }
    }
  },
};
</script>
<style>
.main-container.reservation {
  display: flex;
  flex-direction: column;
  gap: 20px !important;
}

.table-layout {
  display: block;
}

.table-layout img {
  width: 100%;
  margin: 0 auto;
}

.lantai-picker {
  border: 1px solid #cecece;
}

.lantai-picker span {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.seat-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  width: 80%;
  margin: 0 auto;
}

.seat-picker .column {
  flex: 1;
  min-width: calc(25% - 10px);
}

.btn-booking {
  padding-top: 10px;
}

.btn-booking button {
  width: 100%;
  border-radius: 50px;
}

.card-scroll-horizontal {
  overflow-x: auto;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 1rem;
}

.card-scroll-horizontal .delete-item-action {
  position: absolute;
  right: -3px;
  top: -3px;
}

.reservasi-radio-group .v-input__control {
  width: 100% !important;
}


.vue__time-picker .display-time {
  border-radius: 4px;
}
</style>